import React, { ComponentProps, useMemo } from "react";
import Highlighter from "react-highlight-words";
import { isNil } from "ramda";
import { styled } from "styled-components";

const Mark = styled.mark.attrs(() => ({ "data-testid": "highlight" }) as Partial<React.HTMLAttributes<HTMLElement>>)`
  background-color: ${({ theme }) => theme.colours.grey[300]};
`;

const MarkComponent: React.FC<ComponentProps<typeof Mark>> = ({ ...props }) => <Mark {...props} />;

export type HighlightProps = { text?: string | null; searchTerm?: string | null };
export const Highlight: React.FC<HighlightProps> = ({ text, searchTerm }) => {
  const searchWords = useMemo(() => searchTerm?.split(" ") ?? [], [searchTerm]);
  return isNil(text) ? (
    <></>
  ) : (
    <Highlighter highlightTag={MarkComponent} searchWords={searchWords} textToHighlight={text} />
  );
};
